export default __webpack_public_path__ + "static/media/icon_filter.71f97481.svg";